import React from 'react';

const VARIANTS = {
  billable: 'bg-ok-soft text-ok border-ok/25',
  header: 'bg-surface-2 text-muted border-line/30',
  hcc: 'bg-sky-soft text-primary border-primary/25',
  new: 'bg-pop text-navy border-transparent',
  revised: 'bg-sun text-sun-ink border-transparent',
  deleted: 'bg-danger-soft text-danger border-danger/25',
  info: 'bg-sky-soft text-ink border-line/25',
  warning: 'bg-warn-soft text-warn border-warn/25',
  error: 'bg-danger-soft text-danger border-danger/25',
};

export default function Badge({ variant = 'info', children, className = '', title }) {
  return (
    <span title={title} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[10.5px] font-bold uppercase leading-4 tracking-[0.06em] ${VARIANTS[variant] || VARIANTS.info} ${className}`}>
      {children}
    </span>
  );
}
